<template>
  <div class="page-title">
    {{ $t("announcement_page_title") }}
  </div>
  <div class="intro">
    {{ $t("announcement_subtitle") }}
  </div>

  <el-row :gutter="32">
    <el-col :lg="12" :md="24">
      <div class="table-header">
        <HeadingTitle>
          <template #svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="44"
              height="47"
              viewBox="0 0 44 47"
            >
              <g
                id="Gruppe_317"
                data-name="Gruppe 317"
                transform="translate(-182 -241)"
              >
                <g
                  id="Rechteck_125"
                  data-name="Rechteck 125"
                  transform="translate(190 241)"
                  fill="none"
                  stroke="#fff"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                >
                  <rect width="36" height="40" rx="4" stroke="none" />
                  <rect
                    x="0.75"
                    y="0.75"
                    width="34.5"
                    height="38.5"
                    rx="3.25"
                    fill="none"
                  />
                </g>
              </g>
              <g
                id="Gruppe_316"
                data-name="Gruppe 316"
                transform="translate(-190 -234)"
              >
                <g
                  id="Rechteck_125-2"
                  data-name="Rechteck 125"
                  transform="translate(190 241)"
                  fill="#e18324"
                  stroke="#fff"
                  stroke-linejoin="round"
                  stroke-width="1.5"
                >
                  <rect width="36" height="40" rx="4" stroke="none" />
                  <rect
                    x="0.75"
                    y="0.75"
                    width="34.5"
                    height="38.5"
                    rx="3.25"
                    fill="none"
                  />
                </g>
                <line
                  id="Linie_55"
                  data-name="Linie 55"
                  x2="18.997"
                  transform="translate(198.009 250.871)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="1.5"
                />
                <line
                  id="Linie_56"
                  data-name="Linie 56"
                  x2="18.997"
                  transform="translate(198.009 257.576)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="1.5"
                />
                <line
                  id="Linie_57"
                  data-name="Linie 57"
                  x2="6.705"
                  transform="translate(210.301 270.986)"
                  fill="none"
                  stroke="#fff"
                  stroke-linecap="round"
                  stroke-width="1.5"
                />
              </g>
            </svg>
          </template>
        </HeadingTitle>
        <div class="title">{{ $t("announcement_overview") }}</div>
      </div>
      <div class="table-container">
        <div class="subtitle">{{ $t("current") }}</div>

        <vue-collapsible-panel-group accordion>
          <vue-collapsible-panel
            :name="a.idannouncement_assigned"
            v-for="a in announcements"
            :key="a.idannouncement_assigned"
          >
            <template #title> {{ a.shorttext }} </template>
            <template #time>
              <div class="time-holder">
                <div>
                  <span>{{ $t("at") }}</span
                  ><span>{{ a.startdate }}</span>
                </div>
                <div>
                  <span>{{ $t("till") }}</span
                  ><span>{{ a.enddate }}</span>
                </div>
                <div>
                  <span v-if="a.scheduler">{{
                    $t("time_schedule_cycle")
                  }}</span>
                  <span v-if="!a.scheduler">&nbsp;</span>
                </div>
                <div>
                  <span class="nowrap">{{ a.streetname }}</span>
                </div>
              </div>
            </template>
            <template #actions>
              <Edit @click="edit(a)" />
              <el-popconfirm
                :confirmButtonText="$t('yes')"
                :cancelButtonText="$t('no')"
                :title="$t('deleted_announcement_confirm')"
                @confirm="deleteAnnouncement(a.idannouncement_assigned)"
              >
                <template #reference>
                  <Delete />
                </template>
              </el-popconfirm>
            </template>
            <template #content>
              <div class="announcement-data">
                <div class="row">
                  <div class="col">
                    <div class="company-name">{{ a.firm }}</div>
                    <div class="time">
                      {{ a.starttime }} Uhr - {{ a.endtime }} Uhr
                    </div>
                  </div>
                  <div class="col">
                    <div class="contact">{{ a.contact }}</div>
                    <div class="phone">
                      {{ $t("phone") }}: {{ a.telephone }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <hr />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="restrictions">{{ $t("restrictions") }}</div>
                    <div class="container">{{ a.restrictions }}</div>
                  </div>
                  <div class="col">
                    <div class="duty">{{ $t("duty") }}</div>
                    <div class="container">{{ a.duty }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="description">
                      {{ $t("description_service") }}
                    </div>
                    <div class="container">{{ a.description }}</div>
                  </div>
                  <div class="col">
                    <div class="locations">{{ $t("locations") }}</div>
                    <div class="container">{{ a.streetname }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col vorlage">
                    <gkt-btn @click="setVorlage(a, true)">
                      <template #svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.766"
                          height="19.518"
                          viewBox="0 0 19.766 19.518"
                        >
                          <g
                            id="Gruppe_295"
                            data-name="Gruppe 295"
                            transform="translate(-357.597 -37.452)"
                          >
                            <path
                              id="Pfad_76"
                              data-name="Pfad 76"
                              d="M368.005,48.712"
                              transform="translate(-6.138 -6.666)"
                              fill="none"
                              stroke="#de8021"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Pfad_77"
                              data-name="Pfad 77"
                              d="M368.005,42.046V37.952h15V56.47h-15V53.329"
                              transform="translate(-6.138)"
                              fill="none"
                              stroke="#de8021"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <g
                              id="Gruppe_294"
                              data-name="Gruppe 294"
                              transform="translate(366.459 42.535)"
                            >
                              <line
                                id="Linie_47"
                                data-name="Linie 47"
                                x2="4.66"
                                y2="4.66"
                                transform="translate(0 0)"
                                fill="none"
                                stroke="#de8021"
                                stroke-linecap="round"
                                stroke-miterlimit="10"
                                stroke-width="1"
                              />
                              <line
                                id="Linie_48"
                                data-name="Linie 48"
                                y1="4.66"
                                x2="4.66"
                                transform="translate(0 4.692)"
                                fill="none"
                                stroke="#de8021"
                                stroke-linecap="round"
                                stroke-miterlimit="10"
                                stroke-width="1"
                              />
                            </g>
                            <line
                              id="Linie_49"
                              data-name="Linie 49"
                              x1="13.022"
                              transform="translate(358.097 47.195)"
                              fill="none"
                              stroke="#de8021"
                              stroke-linecap="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                          </g>
                        </svg>
                      </template>
                    </gkt-btn>
                    {{ $t("select_template") }}
                  </div>
                </div>
              </div>
            </template>
          </vue-collapsible-panel>
        </vue-collapsible-panel-group>

        <div class="subtitle"><br /><br />{{ $t("expired") }}</div>

        <vue-collapsible-panel-group accordion>
          <vue-collapsible-panel
            :name="a.idannouncement_assigned"
            v-for="a in announcements_old"
            :key="a.idannouncement_assigned"
          >
            <template #title>
              {{ a.shorttext }}
            </template>
            <template #time>
              <div class="time-holder">
                <div>
                  <span>{{ $t("at") }}</span
                  ><span>{{ a.startdate }}</span>
                </div>
                <div>
                  <span>{{ $t("till") }}</span
                  ><span>{{ a.enddate }}</span>
                </div>
                <div><span>&nbsp;</span></div>
                <div>
                  <span class="nowrap">{{ a.streetname }}</span>
                </div>
              </div>
            </template>

            <template #content>
              <div class="announcement-data">
                <div class="row">
                  <div class="col">
                    <div class="company-name">{{ a.firm }}</div>
                    <div class="time">
                      {{ a.starttime }} Uhr - {{ a.endtime }} Uhr
                    </div>
                  </div>
                  <div class="col">
                    <div class="contact">{{ a.contact }}</div>
                    <div class="phone">
                      {{ $t("phone") }}: {{ a.telephone }}
                    </div>
                  </div>
                </div>
                <div class="row">
                  <hr />
                </div>
                <div class="row">
                  <div class="col">
                    <div class="restrictions">{{ $t("restrictions") }}</div>
                    <div class="container">{{ a.restrictions }}</div>
                  </div>
                  <div class="col">
                    <div class="duty">{{ $t("duty") }}</div>
                    <div class="container">{{ a.duty }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col">
                    <div class="description">
                      {{ $t("description_service") }}
                    </div>
                    <div class="container">{{ a.description }}</div>
                  </div>
                  <div class="col">
                    <div class="locations">{{ $t("locations") }}</div>
                    <div class="container">{{ a.streetname }}</div>
                  </div>
                </div>
                <div class="row">
                  <div class="col vorlage">
                    <gkt-btn @click="setVorlage(a, false)">
                      <template #svg>
                        <svg
                          xmlns="http://www.w3.org/2000/svg"
                          width="19.766"
                          height="19.518"
                          viewBox="0 0 19.766 19.518"
                        >
                          <g
                            id="Gruppe_295"
                            data-name="Gruppe 295"
                            transform="translate(-357.597 -37.452)"
                          >
                            <path
                              id="Pfad_76"
                              data-name="Pfad 76"
                              d="M368.005,48.712"
                              transform="translate(-6.138 -6.666)"
                              fill="none"
                              stroke="#de8021"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <path
                              id="Pfad_77"
                              data-name="Pfad 77"
                              d="M368.005,42.046V37.952h15V56.47h-15V53.329"
                              transform="translate(-6.138)"
                              fill="none"
                              stroke="#de8021"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                            <g
                              id="Gruppe_294"
                              data-name="Gruppe 294"
                              transform="translate(366.459 42.535)"
                            >
                              <line
                                id="Linie_47"
                                data-name="Linie 47"
                                x2="4.66"
                                y2="4.66"
                                transform="translate(0 0)"
                                fill="none"
                                stroke="#de8021"
                                stroke-linecap="round"
                                stroke-miterlimit="10"
                                stroke-width="1"
                              />
                              <line
                                id="Linie_48"
                                data-name="Linie 48"
                                y1="4.66"
                                x2="4.66"
                                transform="translate(0 4.692)"
                                fill="none"
                                stroke="#de8021"
                                stroke-linecap="round"
                                stroke-miterlimit="10"
                                stroke-width="1"
                              />
                            </g>
                            <line
                              id="Linie_49"
                              data-name="Linie 49"
                              x1="13.022"
                              transform="translate(358.097 47.195)"
                              fill="none"
                              stroke="#de8021"
                              stroke-linecap="round"
                              stroke-miterlimit="10"
                              stroke-width="1"
                            />
                          </g>
                        </svg>
                      </template>
                    </gkt-btn>
                    {{ $t("select_template") }}
                  </div>
                </div>
              </div>
            </template>
          </vue-collapsible-panel>
        </vue-collapsible-panel-group>
      </div>
    </el-col>
    <el-col :lg="12" :md="24">
      <div class="table-header">
        <HeadingTitle>
          <template #svg>
            <svg
              xmlns="http://www.w3.org/2000/svg"
              width="47"
              height="40"
              viewBox="0 0 47 40"
            >
              <g
                id="Gruppe_320"
                data-name="Gruppe 320"
                transform="translate(-1186 -309)"
              >
                <g
                  id="Gruppe_318"
                  data-name="Gruppe 318"
                  transform="translate(996 68)"
                >
                  <g
                    id="Rechteck_125"
                    data-name="Rechteck 125"
                    transform="translate(190 241)"
                    fill="none"
                    stroke="#fff"
                    stroke-linejoin="round"
                    stroke-width="1.5"
                  >
                    <rect width="36" height="40" rx="4" stroke="none" />
                    <rect
                      x="0.75"
                      y="0.75"
                      width="34.5"
                      height="38.5"
                      rx="3.25"
                      fill="none"
                    />
                  </g>
                  <line
                    id="Linie_55"
                    data-name="Linie 55"
                    x2="16.491"
                    transform="translate(198.009 250.871)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-width="1.5"
                  />
                  <line
                    id="Linie_56"
                    data-name="Linie 56"
                    x2="10.491"
                    transform="translate(198.009 257.576)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-width="1.5"
                  />
                  <rect
                    id="Rechteck_128"
                    data-name="Rechteck 128"
                    width="27"
                    height="29"
                    transform="translate(210 248)"
                    fill="#e08223"
                  />
                </g>
                <g
                  id="Gruppe_319"
                  data-name="Gruppe 319"
                  transform="translate(1 -0.723)"
                >
                  <line
                    id="Linie_63"
                    data-name="Linie 63"
                    x2="18.776"
                    transform="translate(1210.5 331.81)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-width="2"
                  />
                  <line
                    id="Linie_64"
                    data-name="Linie 64"
                    x2="18.776"
                    transform="translate(1219.888 322.048) rotate(90)"
                    fill="none"
                    stroke="#fff"
                    stroke-linecap="round"
                    stroke-width="2"
                  />
                </g>
              </g>
            </svg>
          </template>
        </HeadingTitle>
        <div class="title" v-if="!editAnnouncement">
          {{ $t("create_announcement") }}
        </div>
        <div class="title" v-if="editAnnouncement">
          {{ $t("edit_announcement") }}
        </div>
      </div>
      <div class="table-container">
        <el-form :model="ruleForm" status-icon :rules="rules" ref="ruleForm">
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("announcement_information") }}</div>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="provider">
                <Multiselect
                  v-model="ruleForm.provider"
                  :placeholder="$t('chose_provider')"
                  label="name"
                  trackBy="name"
                  valueProp="idserviceProvider"
                  :options="providers"
                  :searchable="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="firm">
                <el-input
                  v-model="ruleForm.firm"
                  :placeholder="$t('company')"
                ></el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="service">
                <Multiselect
                  :disabled="!ruleForm.provider || ruleForm.provider == ''"
                  v-model="ruleForm.service"
                  :placeholder="$t('chose_service')"
                  label="name"
                  trackBy="name"
                  valueProp="idserviceType"
                  :options="services"
                  :searchable="true"
                />
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="shorttext">
                <el-input
                  v-model="ruleForm.shorttext"
                  :placeholder="$t('title')"
                ></el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <div class="subtitle">{{ $t("date") }}</div>
            </el-col>
            <el-col :span="12">
              <div class="subtitle">{{ $t("period") }}</div>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="date_range">
                <el-date-picker
                  class="gkt-date-picker"
                  v-model="ruleForm.date_range"
                  type="daterange"
                  size="mini"
                  :disabled-date="disabledDate"
                  unlink-panels
                  :range-separator="$t('to')"
                  :start-placeholder="$t('start')"
                  :end-placeholder="$t('end')"
                >
                </el-date-picker>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-col :span="12">
                <el-form-item prop="start_time">
                  <el-time-select
                    class="gkt-time-select"
                    size="mini"
                    :placeholder="$t('start_time')"
                    v-model="ruleForm.start_time"
                    start="06:00"
                    step="00:30"
                    end="20:00"
                    :key="ruleForm.start_time"
                    :maxTime="ruleForm.end_time"
                  >
                  </el-time-select>
                </el-form-item>
              </el-col>
              <el-col :span="12">
                <el-form-item prop="end_time">
                  <el-time-select
                    class="gkt-time-select"
                    size="mini"
                    :placeholder="$t('end_time')"
                    v-model="ruleForm.end_time"
                    start="06:00"
                    step="00:30"
                    end="20:00"
                    :key="ruleForm.end_time"
                    :minTime="ruleForm.start_time"
                  >
                  </el-time-select>
                </el-form-item>
              </el-col>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("show_weekend") }}</div>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="restrictions">
                <el-select
                  v-model="weekend_control"
                  :placeholder="$t('select')"
                >
                  <el-option
                    v-for="item in weekendControlList"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item prop="restrictions" :label="$t('restrictions')">
                <el-input type="textarea" :rows="5" v-model="restrictions">
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item prop="duty" :label="$t('duty')">
                <el-input type="textarea" :rows="5" v-model="duty"> </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="12">
              <el-form-item
                prop="contact"
                :label="editAnnouncement ? $t('contact_on_site') : ''"
              >
                <el-input
                  :placeholder="$t('contact_on_site')"
                  v-model="ruleForm.contact"
                >
                </el-input>
              </el-form-item>
            </el-col>
            <el-col :span="12">
              <el-form-item
                prop="phone"
                :label="editAnnouncement ? $t('contact_phone') : ''"
              >
                <el-input :placeholder="$t('contact_phone')" v-model="phone">
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("description_service") }}</div>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="description">
                <el-input
                  type="textarea"
                  :rows="5"
                  v-model="ruleForm.description"
                >
                </el-input>
              </el-form-item>
            </el-col>
          </el-row>

          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("location_for_announcement") }}</div>
            </el-col>
            <el-col :span="24" v-if="!editAnnouncement">
              <el-form-item>
                <el-checkbox
                  v-model="single_locations"
                  :label="$t('single_locations')"
                  border
                ></el-checkbox>
              </el-form-item>
              <el-form-item v-if="!single_locations" prop="groups">
                <MultiSelect
                  v-model="ruleForm.groups"
                  :options="virtualgroups"
                  :filter="true"
                  optionValue="idvirtualgroup"
                  optionLabel="name"
                  :placeholder="$t('chose_group')"
                />
              </el-form-item>
              <el-form-item v-if="single_locations" prop="cities">
                <MultiSelect
                  v-model="ruleForm.cities"
                  :options="locations"
                  :filter="true"
                  optionValue="idlocation"
                  optionLabel="name"
                  :placeholder="$t('locations_for_group')"
                />
              </el-form-item>
            </el-col>
            <el-col :span="24" v-if="editAnnouncement">
              <!-- show adress(streetname) only no id -->
              <div class="subtitle">{{ editAnnouncement.streetname }}</div>
            </el-col>
          </el-row>
          <!-- start:time scheduler -->
          <el-row :gutter="24">
            <el-col :span="24">
              <div class="subtitle">{{ $t("time_schedule") }}</div>
            </el-col>
            <el-col :span="24">
              <el-form-item prop="scheduler_active">
                <el-select
                  v-model="scheduler_active"
                  :placeholder="$t('time_schedule_none')"
                >
                  <el-option
                    v-for="item in scheduledControlList"
                    :key="item.id"
                    :label="item.value"
                    :value="item.id"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-col>
            <el-col>
              <el-form-item
                v-if="scheduler_active == '1'"
                prop="scheduler_days"
              >
                <MultiSelect
                  v-model="ruleForm.scheduler_days"
                  :filter="true"
                  optionLabel="name"
                  optionValue="id"
                  :options="scheduledControlListDays"
                  :placeholder="$t('time_schedule_selectdays')"
                  @change="sortDays()"
                />
              </el-form-item>
              <el-form-item
                v-if="scheduler_active == '1'"
                prop="scheduler_weekly"
              >
                <MultiSelect
                  v-model="ruleForm.scheduler_weekly"
                  :filter="true"
                  optionLabel="name"
                  optionValue="id"
                  :options="scheduledControlRepeatWeekly"
                  :placeholder="$t('time_schedule_weekcycle')"
                />
              </el-form-item>
              <el-form-item
                v-if="scheduler_active == '1'"
                prop="scheduler_monthly"
              >
                <MultiSelect
                  v-model="ruleForm.scheduler_monthly"
                  :filter="true"
                  optionLabel="name"
                  optionValue="id"
                  :options="scheduledControlRepeatMonth"
                  :placeholder="$t('time_schedule_monthcycle')"
                />
              </el-form-item>
            </el-col>
          </el-row>
          <!-- end:time scheduler -->

          <el-form-item v-if="!editAnnouncement">
            <el-button
              type="primary"
              round
              @click="submitForm('ruleForm')"
              :loading="loading"
              >{{ $t("create") }}</el-button
            >
          </el-form-item>

          <el-form-item v-if="editAnnouncement">
            <el-button type="danger" round @click="cancelEdit()">{{
              $t("cancel")
            }}</el-button>

            <el-button round @click="submitForm('ruleForm')">{{
              $t("save")
            }}</el-button>
          </el-form-item>
        </el-form>
      </div>
    </el-col>
  </el-row>
</template>

<style lang="scss" scoped>
:deep(div.gkt-date-picker) {
  width: 180px;

  input {
    font-size: 9px;
  }

  span.el-range-separator {
    font-size: 8px;
    width: 22px;
  }
}

:deep(div.gkt-time-select) {
  width: 108px;
  margin-right: 12px;
  margin-bottom: 12px;

  input {
    font-size: 9px;
  }

  span.el-range-separator {
    font-size: 8px;
  }
}

.el-collapse {
  margin-bottom: 24px;

  ::v-deep(.el-collapse-item__wrap) {
    background-color: transparent !important;
    padding-top: 12px;
  }

  ::v-deep(.el-collapse-item__header) {
    background-color: #e6e6e6 !important;
    padding: 0 12px;
  }
}

.announcement-data {
  padding: 12px 0 12px 0;
  font-size: 13px;

  hr {
    display: block;
    height: 1px;
    border: 0;
    border-top: 1px solid $gkt-orange;
    margin: 0;
    padding: 0;
    width: 100%;
    margin-bottom: 24px;
  }

  .row {
    display: flex;
    justify-content: space-between;
    margin-bottom: 12px;

    .vorlage {
      padding: 24px;
      display: flex;
      justify-content: flex-end;
      line-height: 38px;

      .gkt-btn {
        margin-right: 12px;
      }
    }

    .company-name,
    .time,
    .contact,
    .phone {
      font-size: 15px;
      color: $gkt-orange;
    }

    .restrictions,
    .duty,
    .description,
    .locations {
      margin-bottom: 24px;
      position: relative;
      font-weight: 500;

      &::before {
        position: absolute;
        width: 100%;
        height: 1px;
        background-color: $gkt-orange;
        bottom: -6px;
        content: "";
      }
    }

    .container {
      min-height: 44px;
      padding-right: 24px;
    }

    .restrictions,
    .description {
      &::before {
        width: calc(100% - 48px);
      }
    }

    .col {
      flex: 1;
    }
  }
}

::v-deep(.el-form-item) {
  .el-form-item__label {
    font-size: 15px;
    color: $gkt-orange-rgba;
    margin-bottom: 12px;
  }
}

.table-header {
  background-color: $gkt-orange-rgba;
  padding: 24px;
  border-top-left-radius: 21px;
  border-top-right-radius: 21px;
  display: flex;
  align-items: center;
  padding-bottom: 72px;

  .title {
    font-size: 21px;
    font-weight: 500;
    color: $gkt-white;
  }
}

.actions {
  position: relative;
  display: flex;
  align-self: center;
  justify-content: flex-end;
  flex: 1;
  z-index: 666;

  .small-rounded-btn.toggle-up {
    display: none;
  }
}

.subtitle {
  font-size: 15px;
  color: $gkt-orange-rgba;
  margin-bottom: 12px;
}

.table-container {
  padding: 24px 48px;
  background-color: $gkt-light-grey;
  border-radius: 21px;

  position: relative;
  top: -48px;

  .assigned-services {
    font-size: 15px;
    font-weight: 500;
    color: $gkt-orange;
  }

  .no-services {
    margin-top: 12px;
    color: darken($gkt-light-grey, 10);
  }

  .services {
    margin: 0;
    padding: 0;
    margin-top: 12px;
    list-style: none;

    li {
      display: flex;
      justify-content: space-between;
      cursor: pointer;
      justify-items: center;
      align-content: center;
      align-items: center;
    }
  }
}

.p-multiselect {
  width: 100%;
  border-radius: 35px;
  padding-left: 24px;
  height: 44px;

  :deep(.p-multiselect-label) {
    padding: 0;
  }
}
.nowrap {
  white-space: nowrap;
}
</style>

<script>
import { provide } from "vue";
import store from "@/store";
import { Edit, Delete, HeadingTitle, GktBtn } from "@/components/buttons";
import VueCollapsiblePanelGroup from "@/components/collapsible/VueCollapsiblePanelGroup.vue";
import VueCollapsiblePanel from "@/components/collapsible/VueCollapsiblePanel.vue";
import Multiselect from "@vueform/multiselect";
import MultiSelect from "primevue/multiselect";

export default {
  name: "announcements",
  setup() {
    provide("store", store);
  },
  components: {
    Delete,
    HeadingTitle,
    Edit,
    VueCollapsiblePanelGroup,
    VueCollapsiblePanel,
    Multiselect,
    MultiSelect,
    GktBtn
  },
  data() {
    var validateDate = (rule, value, callback) => {
      if (value.length == 0) {
        callback(new Error(this.$t("select_date")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("date_range");
        }
        callback();
      }
    };

    var validateShorttext = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("no_title")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("shorttext");
        }
        callback();
      }
    };

    var validateDescription = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("no_description")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("description");
        }
        callback();
      }
    };

    var validateFirm = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("no_company")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("firm");
        }
        callback();
      }
    };

    var validateContact = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("no_contact")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("contact");
        }
        callback();
      }
    };

    var validateStartTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("no_start_time")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("start_time");
        }
        callback();
      }
    };

    var validateEndTime = (rule, value, callback) => {
      if (value == "") {
        callback(new Error(this.$t("no_end_time")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("end_time");
        }
        callback();
      }
    };

    var validateGroups = (rule, value, callback) => {
      if (value.length == 0 && !this.single_locations) {
        callback(new Error(this.$t("no_group")));
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("groups");
        }
        callback();
      }
    };

    var validateCities = (rule, value, callback) => {
      if (value.length == 0 && this.single_locations) {
        if (!this.editAnnouncement) {
          callback(new Error(this.$t("no_location")));
        }
      } else {
        if (this.ruleForm.name !== "") {
          this.$refs.ruleForm.validateField("cities");
        }
        callback();
      }
    };

    var validateSchedulerDays = (rule, value, callback) => {
      console.log("validateSchedulerDays");
      if (value == "") {
        callback(new Error(this.$t("time_schedule_error_day")));
      } else {
        if (this.ruleForm.scheduler_days !== "") {
          //this.$refs.ruleForm.validateField("scheduler_days");
        }
        callback();
      }
    };
    var validateSchedulerWeekly = (rule, value, callback) => {
      console.log("validateSchedulerWeek");
      if (value == "") {
        callback(new Error(this.$t("time_schedule_error_weekly")));
      } else {
        callback();
      }
    };
    var validateSchedulerMonthly = (rule, value, callback) => {
      console.log("validateSchedulerMonth");
      if (value == "") {
        callback(new Error(this.$t("time_schedule_error_monthly")));
      } else {
        callback();
      }
    };

    return {
      ruleForm: {
        date_range: [],
        groups: [],
        cities: [],
        provider: "",
        service: "",
        shorttext: "",
        firm: "",
        contact: "",
        start_time: "",
        end_time: "",
        description: "",
        scheduler_days: "",
        scheduler_weekly: "",
        scheduler_monthly: ""
      },
      single_locations: false,
      rules: {
        scheduler_days: [{ validator: validateSchedulerDays, trigger: "blur" }],
        scheduler_weekly: [
          { validator: validateSchedulerWeekly, trigger: "blur" }
        ],
        scheduler_monthly: [
          { validator: validateSchedulerMonthly, trigger: "blur" }
        ],
        shorttext: [{ validator: validateShorttext, trigger: "blur" }],
        date_range: [{ validator: validateDate, trigger: "change" }],
        firm: [{ validator: validateFirm, trigger: "blur" }],
        contact: [{ validator: validateContact, trigger: "blur" }],
        start_time: [{ validator: validateStartTime, trigger: "change" }],
        end_time: [{ validator: validateEndTime, trigger: "change" }],
        description: [{ validator: validateDescription, trigger: "blur" }],
        groups: [{ validator: validateGroups, trigger: "blur" }],
        cities: [{ validator: validateCities, trigger: "blur" }]
      },
      providers: [],
      phone: "",
      restrictions: "",
      duty: "",
      services: [],
      locations: [],
      virtualgroups_mapping: [],
      virtualgroups: [],
      editAnnouncement: false,
      weekend_control: "no",
      scheduler_active: this.$t("time_schedule_none"),

      weekendControlList: [
        { value: this.$t("no"), id: "no" },
        { value: this.$t("only_saturday"), id: "only_saturday" },
        { value: this.$t("only_sunday"), id: "only_sunday" },
        { value: this.$t("yes"), id: "yes" }
      ],
      scheduledControlList: [
        { value: this.$t("time_schedule_none"), id: 0 },
        { value: this.$t("time_schedule_aktiv"), id: 1 }
      ],
      //id day in week are like date.getday sunday=0
      scheduledControlListDays: [
        { name: this.$t("monday"), id: 1 },
        { name: this.$t("tuesday"), id: 2 },
        { name: this.$t("wednesday"), id: 3 },
        { name: this.$t("thursday"), id: 4 },
        { name: this.$t("friday"), id: 5 },
        { name: this.$t("saturday"), id: 6 },
        { name: this.$t("sunday"), id: 0 }
      ],
      scheduledControlRepeatWeekly: [
        { name: this.$t("time_schedule_every_week_none"), id: "none" },
        { name: this.$t("time_schedule_every_week"), id: "everyweek" },
        { name: this.$t("time_schedule_every_week2"), id: "every2week" },
        { name: this.$t("time_schedule_every_week3"), id: "every3week" },
        { name: this.$t("time_schedule_every_week4"), id: "every4week" },

        {
          name: this.$t("time_schedule_every_week_1stday"),
          id: "1st_day_occurence"
        },
        {
          name: this.$t("time_schedule_every_week_2stday"),
          id: "2nd_day_occurence"
        },
        {
          name: this.$t("time_schedule_every_week_3stday"),
          id: "3th_day_occurence"
        },
        {
          name: this.$t("time_schedule_every_week_4stday"),
          id: "4th_day_occurence"
        }
      ],
      scheduledControlRepeatMonth: [
        { name: this.$t("time_schedule_every_month"), id: 1 },
        { name: this.$t("time_schedule_every_month2"), id: 2 },
        { name: this.$t("time_schedule_every_month3"), id: 3 },
        { name: this.$t("time_schedule_every_month4"), id: 4 },
        { name: this.$t("time_schedule_every_month6"), id: 6 }
      ],
      store,
      announcements: [],
      announcements_old: [],
      loading: false
    };
  },
  watch: {
    changedProvider: function(id) {
      const provider = this.providers.find(it => it.idserviceProvider == id);

      if (provider) {
        this.ruleForm.firm = provider.name;
        this.services = provider.servicetypes;
      } else {
        this.services = [];
      }
    },
    changedGroups: function() {
      this.$refs.ruleForm.validateField("groups");
    },
    changedCities: function() {
      this.$refs.ruleForm.validateField("cities");
    },
    changedService: function(id) {
      const service = this.services.find(it => it.idserviceType == id);

      if (service) {
        this.ruleForm.shorttext = service.name;
      }
    }
  },
  computed: {
    changedProvider: function() {
      return this.ruleForm.provider;
    },
    changedGroups: function() {
      return this.ruleForm.groups;
    },
    changedCities: function() {
      return this.ruleForm.cities;
    },
    changedService: function() {
      return this.ruleForm.service;
    }
  },
  methods: {
    sortDays: function() {
      var test = this.ruleForm.scheduler_days.sort();
      //sunday is "0" put it to the end of list
      if (test.length > 0) {
        if (test[0] == 0) {
          test.shift();
          test.push(0);
        }
      }
      this.ruleForm.scheduler_days = test;
    },
    setVorlage(a, empty) {
      this.clearData();

      this.ruleForm.shorttext = a.shorttext;
      this.ruleForm.description = a.description;
      this.ruleForm.contact = a.contact;
      this.ruleForm.start_time = a.starttime;
      this.ruleForm.end_time = a.endtime;
      this.phone = a.telephone;
      this.restrictions = a.restrictions;
      this.duty = a.duty;
      this.ruleForm.firm = a.firm;
      this.weekend_control = a.weekend_control;
      if (!empty) {
        this.single_locations = true;
      } else {
        //remove Obj
        this.editAnnouncement = null;
        this.single_locations = false;
      }

      this.ruleForm.scheduler_days = [];
      this.ruleForm.scheduler_weekly = [];
      this.ruleForm.scheduler_monthly = [];
      this.scheduler_active = 0;
      if (a.scheduler) {
        if (a.scheduler.days) {
          this.ruleForm.scheduler_days = a.scheduler.days;
          this.scheduler_active = 1;
        }
        if (a.scheduler.weekly) {
          this.ruleForm.scheduler_weekly = a.scheduler.weekly;
          this.scheduler_active = 1;
        }
        if (a.scheduler.monthly) {
          this.ruleForm.scheduler_monthly = a.scheduler.monthly;
          this.scheduler_active = 1;
        }
      }
    },
    disabledDate(time) {
      if (this.scheduler_active == 1) {
        return false;
      } else {
        const d = new Date();
        d.setDate(d.getDate() - 1);
        return time.getTime() < d;
      }
    },
    edit(a) {
      this.editAnnouncement = a;

      this.setVorlage(a, false);

      const enddate = a.enddate.split(".");
      const startdate = a.startdate.split(".");

      this.ruleForm.date_range.push(
        startdate[2] + "-" + startdate[1] + "-" + startdate[0]
      );
      this.ruleForm.date_range.push(
        enddate[2] + "-" + enddate[1] + "-" + enddate[0]
      );
    },
    addService() {
      this.addServiceDialog = true;
    },
    async deleteServiceByIndex(i) {
      const index = this.services.findIndex(function(item) {
        return item.id == i;
      });

      if (index !== -1) {
        const service = this.services[index];

        if (service.idserviceType) {
          this.deleteService(service.idserviceType);
        }

        this.services.splice(index, 1);
      }
    },
    cancelEdit() {
      this.editAnnouncement = false;
      this.clearData();
    },
    clearData() {
      this.ruleForm = {
        date_range: [],
        groups: [],
        cities: [],
        provider: "",
        service: "",
        shorttext: "",
        firm: "",
        contact: "",
        start_time: "",
        end_time: "",
        description: ""
      };

      this.phone = "";
      this.restrictions = "";
      this.duty = "";
      this.weekend_control = "no";
    },
    submitForm(formName) {
      this.loading = true;
      this.$refs[formName].validate(async valid => {
        if (valid) {
          const formattedDate = new Date(this.ruleForm.date_range[0]);

          formattedDate.setDate(formattedDate.getDate());
          let check_date_formatted = formattedDate.toISOString().split("T")[0];

          const formattedDate2 = new Date(this.ruleForm.date_range[1]);

          formattedDate2.setDate(formattedDate2.getDate());
          let check_date_formatted2 = formattedDate2
            .toISOString()
            .split("T")[0];

          check_date_formatted = check_date_formatted.split("-");
          check_date_formatted =
            check_date_formatted[2] +
            "." +
            check_date_formatted[1] +
            "." +
            check_date_formatted[0];

          check_date_formatted2 = check_date_formatted2.split("-");
          check_date_formatted2 =
            check_date_formatted2[2] +
            "." +
            check_date_formatted2[1] +
            "." +
            check_date_formatted2[0];

          const locations = [];
          const that = this;

          if (this.single_locations) {
            this.ruleForm.cities.forEach(function(loc) {
              if (!locations.includes(loc)) locations.push(loc);
            });
          } else {
            this.ruleForm.groups.forEach(function(item) {
              const mapping = that.virtualgroups_mapping[item];
              if (mapping) {
                Object.keys(mapping.idlocations).forEach(function(loc) {
                  if (!locations.includes(loc)) locations.push(loc);
                });
              }
            });
          }

          const parameters = {
            firm: this.ruleForm.firm,
            contact: this.ruleForm.contact,
            shorttext: this.ruleForm.shorttext,
            description: this.ruleForm.description,
            telephone: this.phone,
            startdate: check_date_formatted,
            enddate: check_date_formatted2,
            starttime: this.ruleForm.start_time,
            endtime: this.ruleForm.end_time,
            duty: this.duty,
            restrictions: this.restrictions,
            weekend_control: this.weekend_control,
            locations: locations
          };
          //check time scheduler
          console.log("check time scheduler" + this.scheduler_active);
          if (this.scheduler_active == 1) {
            parameters.scheduler = {};
            parameters.scheduler.days = [];
            parameters.scheduler.weekly = [];
            parameters.scheduler.monthly = [];

            this.ruleForm.scheduler_days.forEach(function(day) {
              parameters.scheduler.days.push(day);
            });
            this.ruleForm.scheduler_weekly.forEach(function(week) {
              parameters.scheduler.weekly.push(week);
            });
            this.ruleForm.scheduler_monthly.forEach(function(month) {
              parameters.scheduler.monthly.push(month);
            });
            console.log(parameters);
          }

          let msg = this.$t("announcement_created");
          let endpoint = "assignannouncement";

          if (this.editAnnouncement) {
            msg = this.$t("announcement_changed");
            endpoint = "changeannouncement";

            parameters.idannouncement_assigned = this.editAnnouncement.idannouncement_assigned;
            //remove locations(plural is misleading)
            delete parameters.locations;
          }

          const response = await store.methods.apiRequest(endpoint, parameters);
          const res = response.data;
          this.loading = false;
          if (res.status == "success") {
            this.$message({
              showClose: true,
              message: msg,
              type: "success",
              offset: 350
            });

            this.clearData();
            this.getAnnouncements();
          } else {
            this.$message({
              showClose: true,
              message: res.errordetails,
              type: "error",
              offset: 350
            });
          }
        } else {
          this.loading = false;
          return false;
        }
      });
    },
    async deleteAnnouncement(id) {
      const response = await store.methods.apiRequest(
        "deleteannouncementassigned",
        {
          idannouncement_assigned: id
        }
      );

      const res = response.data;

      if (res.status == "success") {
        this.$message({
          showClose: true,
          message: this.$t("announcement_deleted"),
          type: "success",
          offset: 350
        });

        this.getAnnouncements();
      } else {
        this.$message({
          showClose: true,
          message: res.errordetails,
          type: "error",
          offset: 350
        });
      }
    },
    async getProviders() {
      const response = await store.methods.apiRequest("getproviders");
      const res = response.data;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results && res.results.providers) {
        this.providers = res.results.providers;
      }
    },
    async getAnnouncements() {
      const response = await store.methods.apiRequest(
        "getannouncements_assigned"
      );
      const res = response.data;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results && res.results.announcements) {
        const today = new Date();
        this.announcements_old = [];
        this.announcements = [];

        const yesterday = new Date();

        yesterday.setDate(today.getDate() - 1);

        res.results.announcements.forEach(an => {
          const sliced = an.enddate.split(".");
          const compare = new Date(
            sliced[2] + "-" + sliced[1] + "-" + sliced[0]
          );

          if (compare < yesterday) {
            this.announcements_old.push(an);
          } else {
            this.announcements.push(an);
          }
        });
      }
    },
    async getVirtualGroups() {
      const response = await store.methods.apiRequest("getDataVirtualGroup");
      const res = response.data;

      if (res.errordetails) {
        console.log("error", res.errordetails);
      }

      if (res.results && res.results.virtualgroups) {
        this.virtualgroups = res.results.virtualgroups;
      }

      if (res.results && res.results.virtualgroups_mapping) {
        this.virtualgroups_mapping = res.results.virtualgroups_mapping;
      }

      if (res.results && res.results.locations) {
        this.locations = res.results.locations[0];
      }
    }
  },
  async mounted() {
    this.getProviders();
    this.getAnnouncements();
    this.getVirtualGroups();
  }
};
</script>
